
<template>
    <section class="hero is-fullheight login-page">
        <div class="hero-body">
            <div class="container login-container">
                <div class="columns is-centered">
                    <div class="column is-10-desktop is-11-tablet">
                        <div class="box whitebox login-card">
                            <div class="columns is-vcentered is-gapless">
                                <div class="column is-7 login-brand-panel">
                                    <span class="login-eyebrow"></span>
                                    <img v-if="config.logoBase64" class="login-logo" :src="'data:image/png;base64, ' + config.logoBase64" alt="MyIndústria" />
                                    <img v-else class="login-logo" src="../assets/logo.png" alt="MyIndústria" />
                                    <p class="login-brand-copy">Sua operação conectada, organizada e pronta para produzir.</p>
                                </div>
                                <div class="column login-form-panel">
                                    <div class="login-form-heading">
                                        <span class="login-kicker">Acesso seguro</span>
                                        <h1>{{ lostingPassword || ReturnToken ? 'Recuperar acesso' : 'Bem-vindo' }}</h1>
                                        <p>{{ lostingPassword || ReturnToken ? 'Informe os dados abaixo para continuar.' : 'Entre com suas credenciais para acessar o sistema.' }}</p>
                                    </div>
                                    <div v-if="erros.length > 0" class="notification is-danger">
                                        <ul>
                                            <li v-for="(erro, index) in erros" v-bind:key="index">
                                                {{ erro }}
                                            </li>
                                        </ul>                                        
                                    </div>
                                    <form  @submit.prevent="onSubmit" method="post" role="form">
                                        <div v-if="!lostingPassword && !ReturnToken">
                                            <b-field label="Usuário">
                                                <b-input icon="account" required v-model="UserName"></b-input>
                                            </b-field>
                                            <b-field label="Senha">
                                                <b-input type="password" icon="lock" password-reveal required v-model="Password"></b-input>
                                            </b-field>
                                            <button type="submit" class="button is-primary is-fullwidth login-submit">Entrar</button>
                                            <p class="has-text-centered is-size-7">
                                                <a @click="lostPassword()">Esqueceu a senha?</a>
                                            </p>                                            
                                        </div>
                                        <div v-else-if="!ReturnToken">

                                            <b-field label="E-mail">
                                                <b-input icon="account" required v-model="Email"></b-input>
                                            </b-field>
                                            <button type="submit" class="button is-primary is-fullwidth login-submit">Enviar</button>
                                            <button type="button" @click="cancelLostPassword()" class="button is-light is-fullwidth mt-2">Voltar</button>
                                                                                                              
                                        </div>
                                        <div v-else>
                                            <b-field label="Nova Senha">
                                                <b-input type="password" icon="lock" password-reveal required v-model="Password"></b-input>
                                            </b-field>
                                            <b-field label="Confirmar Senha">
                                                <b-input type="password" icon="lock" password-reveal required v-model="ConfirmPassword"></b-input>
                                            </b-field>        
                                            <button type="submit" class="button is-primary is-fullwidth login-submit">Confirmar</button>
                                        </div>

                                    </form>

                                                                      
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="login-credit">desenvolvido por <a target="_blank" rel="noopener noreferrer" href="https://site.myclient.com.br/">MYCLIENT SISTEMAS</a></p>
            </div>            
        </div>
    </section>
</template>

<style scoped>
.login-page {
    position: relative;
    overflow: hidden;
    background:
        radial-gradient(circle at 12% 15%, rgba(32, 164, 155, 0.2), transparent 32%),
        radial-gradient(circle at 88% 85%, rgba(52, 120, 173, 0.18), transparent 34%),
        linear-gradient(135deg, #eef6f7 0%, #f5f8fb 48%, #edf3f8 100%);
}
.login-page::before {
    position: absolute;
    width: 420px;
    height: 420px;
    border: 1px solid rgba(23, 63, 102, 0.08);
    border-radius: 50%;
    content: '';
    transform: translate(-45%, -48%);
}
.login-container {
    position: relative;
    z-index: 1;
}
.login-card {
    overflow: hidden;
    padding: 0;
    border: 1px solid rgba(255, 255, 255, 0.86);
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.94) !important;
    box-shadow: 0 24px 65px rgba(16, 47, 76, 0.14);
}
.login-card .columns.is-gapless > .login-brand-panel {
    display: flex;
    min-height: 470px;
    flex-direction: column;
    justify-content: center;
    padding: clamp(2rem, 5vw, 4rem) !important;
    background: linear-gradient(145deg, rgba(228, 245, 243, 0.92), rgba(236, 243, 249, 0.82));
}
.login-logo {
    width: min(100%, 560px);
    max-height: 230px;
    object-fit: contain;
}
.login-eyebrow,
.login-kicker {
    color: var(--brand-teal-600);
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.13em;
}
.login-brand-copy {
    max-width: 480px;
    margin-top: 1.1rem;
    color: var(--text-muted);
    font-size: 1rem;
}
.login-card .columns.is-gapless > .login-form-panel {
    padding: clamp(2rem, 4vw, 3.2rem) !important;
}
.login-form-heading {
    margin-bottom: 1.5rem;
}
.login-form-heading h1 {
    margin: 0.25rem 0;
    color: var(--text-strong);
    font-size: 1.85rem;
    font-weight: 800;
}
.login-form-heading p {
    color: var(--text-muted);
    font-size: 0.9rem;
}
.login-submit {
    margin-top: 0.75rem;
    min-height: 2.75rem;
}
.login-credit {
    margin-top: 1rem;
    color: var(--text-muted);
    text-align: center;
    font-size: 0.72rem;
}
.login-credit a {
    color: var(--brand-navy-700);
    font-weight: 800;
}
@media (max-width: 768px) {
    .login-page .hero-body {
        padding: 1rem;
    }
    .login-card .columns.is-gapless > .login-brand-panel {
        min-height: auto;
        padding: 1.5rem !important;
        text-align: center;
    }
    .login-brand-copy {
        display: none;
    }
    .login-logo {
        max-height: 130px;
    }
    .login-card .columns.is-gapless > .login-form-panel {
        padding: 1.5rem !important;
    }
}
</style>

<script>
    import http from '@/http'
    import { mapActions, mapState } from 'vuex'
    import jwt from 'jsonwebtoken'

    export default {
        data() {
            return {
                UserName: '',
                Password: '',
                Email: '',
                lostingPassword: false,
                ConfirmPassword: '',
                ReturnToken: null,                
                Token: null,
                GuiaId:null,
                UnidadeId:null,
                CodigoLote:null,
                AssistenciaId:null,
                Tipo:null
            }
        },
        computed: {
            ...mapState([
                'config',
                'erros',
                'usuario'
            ])
        },
        mounted() { 
            setTimeout(() => {
                if (this.$route.query.email) this.Email = this.$route.query.email;
                if (this.$route.query.rt) this.ReturnToken = this.$route.query.rt;                                
                if (this.$route.query.user) this.UserName = this.$route.query.user;
                if (this.$route.query.pass) this.Password = this.$route.query.pass;

                /*
                if(this.UserName!=null && this.Password!=null 
                && this.UserName!='' && this.Password!='' 
                && this.UserName.length>1 && this.Password.length>1  ){
                    this.Password = atob(this.Password);
                    this.onSubmit();
                }
                */

                if (this.$route.query.token) {                    
                    this.Token = this.$route.query.token;
                    const json = jwt.decode(this.Token);
                    this.UserName = json.Nome;
                    this.GuiaId = json.GuiaId;
                    this.UnidadeId = json.UnidadeId;
                    this.CodigoLote = json.CodigoLote;
                    this.AssistenciaId = json.AssistenciaId;
                    this.Tipo = json.Tipo;
                    this.Password = "vazio";
                    this.onSubmit();
                }
                
            

            },500);                     

        },
        
        methods: {
            ...mapActions([
                'login',
                'commit'
            ]),
            lostPassword(){
                this.lostingPassword= true;
            },
            cancelLostPassword(){
                this.lostingPassword= false;
            },            
            onSubmit() {
                // se estiver num portal, sai
                if (this.$route.path.startsWith('/portal/')) {
                    this.$router.push('/')
                }


                if(this.ReturnToken){
                    http.post(`/api/auth/ResetPassword`, 
                    {
                        email : this.Email, 
                        returnToken: this.ReturnToken,
                        Password: this.Password,
                        ConfirmPassword: this.ConfirmPassword
                    }).then(res => res.data)
                      .then(data => {    
                            if(!data.mensagem){
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: "Nova senha foi definida com sucesso!",
                                    type: 'is-success',
                                    queue: false
                                });            
                                this.lostingPassword= false;
                                this.Email='';
                                this.UserName='';
                                this.Password='';
                                this.ConfirmPassword='';
                                this.ReturnToken=null;  

                                this.$router.replace('/');
                            }else{
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: data.mensagem,
                                    type: 'is-danger',
                                    queue: false
                                });                                            
                            }
                
                            
                        })
                        .catch((error) => {    

                            this.$buefy.toast.open({
                                duration: 5000,
                                message: "Ocorreu um erro!",
                                type: 'is-danger',
                                queue: false
                            });                                                    
                            throw error;

                        });                       

                } else if(!this.lostingPassword){


                    this.login({ authMethod: this.authMode, UserName: this.UserName, 
                        Password: this.Password, Token:this.Token, GuiaId:this.GuiaId, UnidadeId: this.UnidadeId, CodigoLote: this.CodigoLote, AssistenciaId: this.AssistenciaId })
                        .then(() => {   
                            if (this.AssistenciaId) {
                                this.$router.replace({ name: 'confirmacao_transportadora_assistencia', params: { assistenciaId: this.AssistenciaId } });
                            } else if (this.Tipo === 'TransportadoraEntregaAstec') {
                                this.$router.replace({ name: 'confirmacao_transportadora_entrega_astec', params: { codigoLote: this.CodigoLote } });
                            } else if (this.CodigoLote) {
                                this.$router.replace({ name: 'confirmacao_transportadora_entrega', params: { codigoLote: this.CodigoLote } });
                            } else {
                                this.$router.replace('/');
                            }
                            return true;                                     
                        });                    
                    
                }else{

                    http.post(`/api/auth/LostPassword`, {email : this.Email})
                        .then(res => res.data)
                        .then(data => {    
                            if(!data.mensagem){
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: "Email de Redefinição de senha foi enviado com sucesso!",
                                    type: 'is-success',
                                    queue: false
                                });            
                                this.lostingPassword= false;
                                this.Email='';
                            }else{
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: data.mensagem,
                                    type: 'is-danger',
                                    queue: false
                                });                                            
                            }
                
                            
                        })
                        .catch((error) => {    

                            this.$buefy.toast.open({
                                duration: 5000,
                                message: "Ocorreu um erro!",
                                type: 'is-danger',
                                queue: false
                            });                                                    
                            throw error;

                        });                    

                }

            }
        }
    }
</script>
